import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (isAuthenticated && !user) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to consent if not consented (and not already on consent page)
  if (user && !user.has_consented && location.pathname !== '/consent') {
    return <Navigate to="/consent" replace />;
  }

  // Redirect to survey if not completed (and not already on survey page)
  if (user && user.has_consented && !user.has_completed_survey && location.pathname !== '/survey') {
    return <Navigate to="/survey" replace />;
  }

  // Render protected content
  return <Outlet />;
};

export default ProtectedRoute;
